import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, getEntityId, getHeaders } from '@urc-ui/store/api/base';
import { HttpMethod, Sort, Tag } from '@urc-ui/store/api/types';
import { GetReportsRequest, getReportsResponse } from '@urc-ui/store/api/reports/types';

export const DEFAULT_SORT_CONFIG: Sort = {
  columnName: 'REPORT_CREATED_ON',
  order: 'DESC'
};

export const buildGetReportsRequest = (pageSize: number, pageOffset: number, subscriptionId: string, nextToken?: string) => {
  return {
    sort: DEFAULT_SORT_CONFIG,
    filters: [
      {
        column_name: 'REPORT_SUBSCRIPTION_ID',
        filter_type: 'EQUAL',
        values: [subscriptionId]
      }
    ],
    pagination: {
      pageLimit: pageSize,
      pageOffset
    },
    subscriptionId,
    ...(nextToken && { nextToken })
  };
};

const transformReport = (report: any) => {
  return {
    id: report.reportId,
    status: report.reportStatus,
    s3Url: report.s3location,
    rossS3Url: report.rossS3Location,
    creationTimestamp: report.completed,
    reportPeriod: report.config?.date_range,
    reportStartDate: report.config?.custom_start_date,
    reportEndDate: report.config?.custom_end_date,
    recipients: report.publisher
  };
};

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/reports/api'
  }),
  tagTypes: [Tag.REPORTS],
  endpoints: builder => ({
    getReports: builder.query({
      query: (request: GetReportsRequest) => {
        return {
          url: `/subscription-reports/${request.subscriptionId}?entityId=${getEntityId()}`,
          method: HttpMethod.POST,
          data: request,
          headers: getHeaders()
        };
      },
      transformResponse: (response: any): getReportsResponse => {
        return {
          reports: response?.reports.map(transformReport),
          totalRowCount: response.totalResults,
          nextToken: response.nextToken
        };
      },
      providesTags: [Tag.REPORTS]
    })
  })
});

export const selectGetReportsResult = (request: GetReportsRequest) => reportsApi.endpoints.getReports.select(request);

export const { useGetReportsQuery, useLazyGetReportsQuery } = reportsApi;
